export const PDFHeaderColumns = [
  { header: 'LRNO', exportHead: 'LRNO', field: 'LRNO', minWidth: '50px', xlCol: { dataType: 'quantity', dataFormatter: null }, align: 'left' },
  {
    header: 'Entry Date',
    exportHead: 'Entry Date',
    field: 'EntryDate',
    minWidth: '150px',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'User Modified',
    exportHead: 'User Modified',
    field: 'UserIDModifiedNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
    minWidth: '150px',
  },
  {
    header: 'Booking CityOld',
    exportHead: 'Booking CityOld',
    field: 'BookingCityOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking CityNew',
    exportHead: 'Booking CityNew',
    field: 'BookingCityNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking\nBranchOld',
    exportHead: 'Booking\nBranchOld',
    field: 'BookingBranchOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking\nBranchNew',
    exportHead: 'Booking BranchNew',
    field: 'BookingBranchNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination CityOld',
    exportHead: 'Destination CityOld',
    field: 'DestinationCityOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination CityNew',
    exportHead: 'Destination CityNew',
    field: 'DestinationCityNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination\nBranchOld',
    exportHead: 'Destination BranchOld',
    field: 'DestinationBranchOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '150px'
  },
  {
    header: 'Destination\nBranchNew',
    exportHead: 'Destination BranchNew',
    field: 'DestinationBranchNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '150px'
  },
  {
    header: 'Destination\nChangeRemarks',
    exportHead: 'Destination\nChangeRemarks',
    field: 'Remarks',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch CityOld',
    exportHead: 'Dispatch CityOld',
    field: 'DispatchCityOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch CityNew',
    exportHead: 'Dispatch CityNew',
    field: 'DispatchCityNew',
    xlCol: { dataType: 'quantity', dataFormatter: null, halign: 'left' },
    align: 'left',
  },
  {
    header: 'Dispatch\nBranchOld',
    exportHead: 'Dispatch BranchOld',
    field: 'DispatchBranchOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '150px'
  },
  {
    header: 'Dispatch\nBranchNew',
    exportHead: 'Dispatch BranchNew',
    field: 'DispatchBranchNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '150px'
  },
  {
    header: 'Dispatch OldVehicle',
    exportHead: 'Dispatch OldVehicle',
    field: 'DispatchVehicleOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '150px'
  },
  {
    header: 'Dispatch NewVehicle',
    exportHead: 'Dispatch NewVehicle',
    field: 'DispatchVehicleNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '150px'
  },
  {
    header: 'Seal Number Old',
    exportHead: 'Seal Number Old',
    field: 'SealNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '100px'
  },
  {
    header: 'Seal Number New',
    exportHead: 'Seal Number New',
    field: 'SealNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '100px'
  },
  {
    header: 'Dispatch DriverOld',
    exportHead: 'Dispatch DriverOld',
    field: 'DispatchDriverOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch DriverNew',
    exportHead: 'Dispatch DriverNew',
    field: 'DispatchDriverNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'ModeOf PaymentOld',
    exportHead: 'ModeOf PaymentOld',
    field: 'ModeOfPaymentOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'ModeOf PaymentNew',
    exportHead: 'ModeOf PaymentNew',
    field: 'ModeOfPaymentNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Payment TypeOld',
    exportHead: 'Payment TypeOld',
    field: 'PaymentTypeOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Payment TypeNew',
    exportHead: 'Payment TypeNew',
    field: 'PaymentTypeNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sending PartyOld',
    exportHead: 'Sending PartyOld',
    field: 'SendingPartyOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sending PartyNew',
    exportHead: 'Sending PartyNew',
    field: 'SendingPartyNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth:'150px'
  },
  {
    header: 'Sender Old',
    exportHead: 'Sender Old',
    field: 'SenderOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender New',
    exportHead: 'Sender New',
    field: 'SenderNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth:'150px'
  },
  {
    header: 'Sender AddressOld',
    exportHead: 'Sender AddressOld',
    field: 'SenderAddressOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender AddressNew',
    exportHead: 'Sender AddressNew',
    field: 'SenderAddressNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender MobileNumberOld',
    exportHead: 'Sender MobileNumberOld',
    field: 'SenderMobileNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender MobileNumberNew',
    exportHead: 'Sender MobileNumberNew',
    field: 'SenderMobileNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver PartyOld',
    exportHead: 'Receiver PartyOld',
    field: 'RecPartyOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver PartyNew',
    exportHead: 'Receiver PartyNew',
    field: 'RecPartyNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver NameOld',
    exportHead: 'Receiver NameOld',
    field: 'RecNameOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver NameNew',
    exportHead: 'Receiver NameNew',
    field: 'RecNameNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '150px'
  },
  {
    header: 'Receiver AddressOld',
    exportHead: 'Receiver AddressOld',
    field: 'RecAddressOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '150px'
  },
  {
    header: 'Receiver AddressNew',
    exportHead: 'Receiver AddressNew',
    field: 'RecAddressNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'RecMobile NoOld',
    exportHead: 'RecMobile NoOld',
    field: 'RecMobileNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'RecMobile NoNew',
    exportHead: 'RecMobile NoNew',
    field: 'RecMobileNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Items Old',
    exportHead: 'Items Old',
    field: 'ItemsOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Items New',
    exportHead: 'Items New',
    field: 'ItemsNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Freight Old',
    exportHead: 'Freight Old',
    field: 'FreightOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Freight New',
    exportHead: 'Freight New',
    field: 'FreightNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Document ChargesOld',
    exportHead: 'Document ChargesOld',
    field: 'DocumentChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Document ChargesNew',
    exportHead: 'Document ChargesNew',
    field: 'DocumentChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'GST Amount Old',
    exportHead: 'GST Amount Old',
    field: 'ServiceTaxAmountOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'GST Amount New',
    exportHead: 'GST Amount New',
    field: 'ServiceTaxAmountNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Insurance Old',
    exportHead: 'Insurance Old',
    field: 'InsuranceOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Insurance New',
    exportHead: 'Insurance New',
    field: 'InsuranceNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Delivery ChargesOld',
    exportHead: 'Delivery ChargesOld',
    field: 'DeliveryChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Delivery ChargesNew',
    exportHead: 'Delivery ChargesNew',
    field: 'DeliveryChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Collection ChargesOld',
    exportHead: 'Collection ChargesOld',
    field: 'CollectionChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Collection ChargesNew',
    exportHead: 'Collection ChargesNew',
    field: 'CollectionChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Cartage AmountOld',
    exportHead: 'Cartage AmountOld',
    field: 'CartageAmountOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Cartage AmountNew',
    exportHead: 'Cartage AmountNew',
    field: 'CartageAmountNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Net AmountOld',
    exportHead: 'Net AmountOld',
    field: 'NetAmountOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Net AmountNew',
    exportHead: 'Net AmountNew',
    field: 'NetAmountNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Remarks Old',
    exportHead: 'Remarks Old',
    field: 'RemarksOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Remarks New',
    exportHead: 'Remarks New',
    field: 'RemarksNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Commission Old',
    exportHead: 'Commission Old',
    field: 'CommissionOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Commission New',
    exportHead: 'Commission New',
    field: 'CommissionNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Demurrage Charge Old',
    exportHead: 'Demurrage Charge Old',
    field: 'DemurrageChgOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Demurrage Charge New',
    exportHead: 'Demurrage Charge New',
    field: 'DemurrageChgNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Hamali Charge Old',
    exportHead: 'Hamali Charge Old',
    field: 'HamaliChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Hamali Charge New',
    exportHead: 'Hamali Charge New',
    field: 'HamaliChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
]
export const PDFHeaderColumnsFormattedLRNO = [
  {
    header: 'Formatted LR Number',
    exportHead: 'Formatted LR Number',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Entry Date',
    exportHead: 'Entry Date',
    field: 'EntryDate',
    minWidth: '100px',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'User Modified',
    exportHead: 'User Modified',
    field: 'UserIDModifiedNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking CityOld',
    exportHead: 'Booking CityOld',
    field: 'BookingCityOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking CityNew',
    exportHead: 'Booking CityNew',
    field: 'BookingCityNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking\nBranchOld',
    exportHead: 'Booking\nBranchOld',
    field: 'BookingBranchOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking\nBranchNew',
    exportHead: 'Booking BranchNew',
    field: 'BookingBranchNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination CityOld',
    exportHead: 'Destination CityOld',
    field: 'DestinationCityOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination CityNew',
    exportHead: 'Destination CityNew',
    field: 'DestinationCityNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination\nBranchOld',
    exportHead: 'Destination BranchOld',
    field: 'DestinationBranchOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination\nBranchNew',
    exportHead: 'Destination BranchNew',
    field: 'DestinationBranchNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination\nChangeRemarks',
    exportHead: 'Destination\nChangeRemarks',
    field: 'Remarks',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch CityOld',
    exportHead: 'Dispatch CityOld',
    field: 'DispatchCityOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch CityNew',
    exportHead: 'Dispatch CityNew',
    field: 'DispatchCityNew',
    xlCol: { dataType: 'quantity', dataFormatter: null, halign: 'left' },
    align: 'left',
  },
  {
    header: 'Dispatch\nBranchOld',
    exportHead: 'Dispatch BranchOld',
    field: 'DispatchBranchOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch\nBranchNew',
    exportHead: 'Dispatch BranchNew',
    field: 'DispatchBranchNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch OldVehicle',
    exportHead: 'Dispatch OldVehicle',
    field: 'DispatchVehicleOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '150px'
  },
  {
    header: 'Dispatch NewVehicle',
    exportHead: 'Dispatch NewVehicle',
    field: 'DispatchVehicleNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '150px'
  },
  {
    header: 'Seal Number Old',
    exportHead: 'Seal Number Old',
    field: 'SealNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Seal Number New',
    exportHead: 'Seal Number New',
    field: 'SealNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch DriverOld',
    exportHead: 'Dispatch DriverOld',
    field: 'DispatchDriverOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch DriverNew',
    exportHead: 'Dispatch DriverNew',
    field: 'DispatchDriverNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'ModeOf PaymentOld',
    exportHead: 'ModeOf PaymentOld',
    field: 'ModeOfPaymentOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'ModeOf PaymentNew',
    exportHead: 'ModeOf PaymentNew',
    field: 'ModeOfPaymentNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Payment TypeOld',
    exportHead: 'Payment TypeOld',
    field: 'PaymentTypeOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Payment TypeNew',
    exportHead: 'Payment TypeNew',
    field: 'PaymentTypeNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sending PartyOld',
    exportHead: 'Sending PartyOld',
    field: 'SendingPartyOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sending PartyNew',
    exportHead: 'Sending PartyNew',
    field: 'SendingPartyNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth:'150px'
  },
  {
    header: 'Sender Old',
    exportHead: 'Sender Old',
    field: 'SenderOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender New',
    exportHead: 'Sender New',
    field: 'SenderNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth:'150px'
  },
  {
    header: 'Sender AddressOld',
    exportHead: 'Sender AddressOld',
    field: 'SenderAddressOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender AddressNew',
    exportHead: 'Sender AddressNew',
    field: 'SenderAddressNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender MobileNoOld',
    exportHead: 'Sender MobileNoOld',
    field: 'SenderMobileNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender MobileNoNew',
    exportHead: 'Sender MobileNoNew',
    field: 'SenderMobileNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver PartyOld',
    exportHead: 'Receiver PartyOld',
    field: 'RecPartyOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver PartyNew',
    exportHead: 'Receiver PartyNew',
    field: 'RecPartyNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver NameOld',
    exportHead: 'Receiver NameOld',
    field: 'RecNameOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver NameNew',
    exportHead: 'Receiver NameNew',
    field: 'RecNameNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver AddressOld',
    exportHead: 'Receiver AddressOld',
    field: 'RecAddressOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver AddressNew',
    exportHead: 'Receiver AddressNew',
    field: 'RecAddressNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'RecMobile Number Old',
    exportHead: 'RecMobile Number Old',
    field: 'RecMobileNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'RecMobile Number New',
    exportHead: 'RecMobile Number New',
    field: 'RecMobileNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Items Old',
    exportHead: 'Items Old',
    field: 'ItemsOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Items New',
    exportHead: 'Items New',
    field: 'ItemsNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Freight Old',
    exportHead: 'Freight Old',
    field: 'FreightOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Freight New',
    exportHead: 'Freight New',
    field: 'FreightNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Document ChargesOld',
    exportHead: 'Document ChargesOld',
    field: 'DocumentChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Document ChargesNew',
    exportHead: 'Document ChargesNew',
    field: 'DocumentChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'GST Amount Old',
    exportHead: 'GST Amount Old',
    field: 'ServiceTaxAmountOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'GST Amount New',
    exportHead: 'GST Amount New',
    field: 'ServiceTaxAmountNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Insurance Old',
    exportHead: 'Insurance Old',
    field: 'InsuranceOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Insurance New',
    exportHead: 'Insurance New',
    field: 'InsuranceNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Delivery ChargesOld',
    exportHead: 'Delivery ChargesOld',
    field: 'DeliveryChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Delivery ChargesNew',
    exportHead: 'Delivery ChargesNew',
    field: 'DeliveryChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Collection ChargesOld',
    exportHead: 'Collection ChargesOld',
    field: 'CollectionChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Collection ChargesNew',
    exportHead: 'Collection ChargesNew',
    field: 'CollectionChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Cartage AmountOld',
    exportHead: 'Cartage AmountOld',
    field: 'CartageAmountOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Cartage AmountNew',
    exportHead: 'Cartage AmountNew',
    field: 'CartageAmountNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Net AmountOld',
    exportHead: 'Net AmountOld',
    field: 'NetAmountOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Net AmountNew',
    exportHead: 'Net AmountNew',
    field: 'NetAmountNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Remarks Old',
    exportHead: 'Remarks Old',
    field: 'RemarksOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Remarks New',
    exportHead: 'Remarks New',
    field: 'RemarksNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Commission Old',
    exportHead: 'Commission Old',
    field: 'CommissionOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Commission New',
    exportHead: 'Commission New',
    field: 'CommissionNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Demurrage Charge Old',
    exportHead: 'Demurrage Charge Old',
    field: 'DemurrageChgOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Demurrage Charge New',
    exportHead: 'Demurrage Charge New',
    field: 'DemurrageChgNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Hamali Charge Old',
    exportHead: 'Hamali Charge Old',
    field: 'HamaliChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Hamali Charge New',
    exportHead: 'Hamali Charge New',
    field: 'HamaliChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
]
export const PDFHeaderColumnsForBoth = [
  { header: 'LR Number', exportHead: 'LR Number', field: 'LRNO', xlCol: { dataType: 'quantity', dataFormatter: null }, align: 'left' },
  {
    header: 'Formatted LR Number',
    exportHead: 'Formatted LR Number',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Entry Date',
    exportHead: 'Entry Date',
    field: 'EntryDate',
    minWidth: '100px',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'User Modified',
    exportHead: 'User Modified',
    field: 'UserIDModifiedNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking CityOld',
    exportHead: 'Booking CityOld',
    field: 'BookingCityOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking CityNew',
    exportHead: 'Booking CityNew',
    field: 'BookingCityNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking\nBranchOld',
    exportHead: 'Booking\nBranchOld',
    field: 'BookingBranchOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking\nBranchNew',
    exportHead: 'Booking BranchNew',
    field: 'BookingBranchNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination CityOld',
    exportHead: 'Destination CityOld',
    field: 'DestinationCityOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination CityNew',
    exportHead: 'Destination CityNew',
    field: 'DestinationCityNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination\nBranchOld',
    exportHead: 'Destination BranchOld',
    field: 'DestinationBranchOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination\nBranchNew',
    exportHead: 'Destination BranchNew',
    field: 'DestinationBranchNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination\nChangeRemarks',
    exportHead: 'Destination\nChangeRemarks',
    field: 'Remarks',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch CityOld',
    exportHead: 'Dispatch CityOld',
    field: 'DispatchCityOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch CityNew',
    exportHead: 'Dispatch CityNew',
    field: 'DispatchCityNew',
    xlCol: { dataType: 'quantity', dataFormatter: null, halign: 'left' },
    align: 'left',
  },
  {
    header: 'Dispatch\nBranchOld',
    exportHead: 'Dispatch BranchOld',
    field: 'DispatchBranchOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch\nBranchNew',
    exportHead: 'Dispatch BranchNew',
    field: 'DispatchBranchNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch OldVehicle',
    exportHead: 'Dispatch OldVehicle',
    field: 'DispatchVehicleOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '150px'
  },
  {
    header: 'Dispatch NewVehicle',
    exportHead: 'Dispatch NewVehicle',
    field: 'DispatchVehicleNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '150px'
  },
  {
    header: 'Seal Number Old',
    exportHead: 'Seal Number Old',
    field: 'SealNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Seal Number New',
    exportHead: 'Seal Number New',
    field: 'SealNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch DriverOld',
    exportHead: 'Dispatch DriverOld',
    field: 'DispatchDriverOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch DriverNew',
    exportHead: 'Dispatch DriverNew',
    field: 'DispatchDriverNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'ModeOf PaymentOld',
    exportHead: 'ModeOf PaymentOld',
    field: 'ModeOfPaymentOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'ModeOf PaymentNew',
    exportHead: 'ModeOf PaymentNew',
    field: 'ModeOfPaymentNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Payment TypeOld',
    exportHead: 'Payment TypeOld',
    field: 'PaymentTypeOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Payment TypeNew',
    exportHead: 'Payment TypeNew',
    field: 'PaymentTypeNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sending PartyOld',
    exportHead: 'Sending PartyOld',
    field: 'SendingPartyOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sending PartyNew',
    exportHead: 'Sending PartyNew',
    field: 'SendingPartyNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth:'150px'
  },
  {
    header: 'Sender Old',
    exportHead: 'Sender Old',
    field: 'SenderOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender New',
    exportHead: 'Sender New',
    field: 'SenderNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth:'150px'
  },
  {
    header: 'Sender AddressOld',
    exportHead: 'Sender AddressOld',
    field: 'SenderAddressOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender AddressNew',
    exportHead: 'Sender AddressNew',
    field: 'SenderAddressNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender MobileNoOld',
    exportHead: 'Sender MobileNoOld',
    field: 'SenderMobileNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender MobileNoNew',
    exportHead: 'Sender MobileNoNew',
    field: 'SenderMobileNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver PartyOld',
    exportHead: 'Receiver PartyOld',
    field: 'RecPartyOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver PartyNew',
    exportHead: 'Receiver PartyNew',
    field: 'RecPartyNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver NameOld',
    exportHead: 'Receiver NameOld',
    field: 'RecNameOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver NameNew',
    exportHead: 'Receiver NameNew',
    field: 'RecNameNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver AddressOld',
    exportHead: 'Receiver AddressOld',
    field: 'RecAddressOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver AddressNew',
    exportHead: 'Receiver AddressNew',
    field: 'RecAddressNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'RecMobile Number Old',
    exportHead: 'RecMobile Number Old',
    field: 'RecMobileNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'RecMobile Number New',
    exportHead: 'RecMobile Number New',
    field: 'RecMobileNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Items Old',
    exportHead: 'Items Old',
    field: 'ItemsOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Items New',
    exportHead: 'Items New',
    field: 'ItemsNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Freight Old',
    exportHead: 'Freight Old',
    field: 'FreightOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Freight New',
    exportHead: 'Freight New',
    field: 'FreightNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Document ChargesOld',
    exportHead: 'Document ChargesOld',
    field: 'DocumentChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Document ChargesNew',
    exportHead: 'Document ChargesNew',
    field: 'DocumentChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'GST Amount Old',
    exportHead: 'GST Amount Old',
    field: 'ServiceTaxAmountOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'GST Amount New',
    exportHead: 'GST Amount New',
    field: 'ServiceTaxAmountNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Insurance Old',
    exportHead: 'Insurance Old',
    field: 'InsuranceOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Insurance New',
    exportHead: 'Insurance New',
    field: 'InsuranceNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Delivery ChargesOld',
    exportHead: 'Delivery ChargesOld',
    field: 'DeliveryChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Delivery ChargesNew',
    exportHead: 'Delivery ChargesNew',
    field: 'DeliveryChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Collection ChargesOld',
    exportHead: 'Collection ChargesOld',
    field: 'CollectionChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Collection ChargesNew',
    exportHead: 'Collection ChargesNew',
    field: 'CollectionChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Cartage AmountOld',
    exportHead: 'Cartage AmountOld',
    field: 'CartageAmountOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Cartage AmountNew',
    exportHead: 'Cartage AmountNew',
    field: 'CartageAmountNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Net AmountOld',
    exportHead: 'Net AmountOld',
    field: 'NetAmountOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Net AmountNew',
    exportHead: 'Net AmountNew',
    field: 'NetAmountNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Remarks Old',
    exportHead: 'Remarks Old',
    field: 'RemarksOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Remarks New',
    exportHead: 'Remarks New',
    field: 'RemarksNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Commission Old',
    exportHead: 'Commission Old',
    field: 'CommissionOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Commission New',
    exportHead: 'Commission New',
    field: 'CommissionNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Demurrage Charge Old',
    exportHead: 'Demurrage Charge Old',
    field: 'DemurrageChgOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Demurrage Charge New',
    exportHead: 'Demurrage Charge New',
    field: 'DemurrageChgNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Hamali Charge Old',
    exportHead: 'Hamali Charge Old',
    field: 'HamaliChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Hamali Charge New',
    exportHead: 'Hamali Charge New',
    field: 'HamaliChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
]
export const PDFHeaderColumnsTwo = [
  { header: 'LR Number', exportHead: 'LR Number', field: 'LRNO', xlCol: { dataType: 'quantity', dataFormatter: null }, align: 'left' },
  {
    header: 'Entry Date',
    exportHead: 'Entry Date',
    field: 'EntryDate',
    minWidth: '100px',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'User Modified',
    exportHead: 'User Modified',
    field: 'UserIDModifiedNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking CityOld',
    exportHead: 'Booking CityOld',
    field: 'BookingCityOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking CityNew',
    exportHead: 'Booking CityNew',
    field: 'BookingCityNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking\nBranchOld',
    exportHead: 'Booking\nBranchOld',
    field: 'BookingBranchOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking\nBranchNew',
    exportHead: 'Booking BranchNew',
    field: 'BookingBranchNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination CityOld',
    exportHead: 'Destination CityOld',
    field: 'DestinationCityOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination CityNew',
    exportHead: 'Destination CityNew',
    field: 'DestinationCityNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination\nBranchOld',
    exportHead: 'Destination BranchOld',
    field: 'DestinationBranchOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination\nBranchNew',
    exportHead: 'Destination BranchNew',
    field: 'DestinationBranchNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination\nChangeRemarks',
    exportHead: 'Destination\nChangeRemarks',
    field: 'Remarks',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch CityOld',
    exportHead: 'Dispatch CityOld',
    field: 'DispatchCityOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch CityNew',
    exportHead: 'Dispatch CityNew',
    field: 'DispatchCityNew',
    xlCol: { dataType: 'quantity', dataFormatter: null, halign: 'left' },
    align: 'left',
  },
  {
    header: 'Dispatch\nBranchOld',
    exportHead: 'Dispatch BranchOld',
    field: 'DispatchBranchOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch\nBranchNew',
    exportHead: 'Dispatch BranchNew',
    field: 'DispatchBranchNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch OldVehicle',
    exportHead: 'Dispatch OldVehicle',
    field: 'DispatchVehicleOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '150px'
  },
  {
    header: 'Dispatch NewVehicle',
    exportHead: 'Dispatch NewVehicle',
    field: 'DispatchVehicleNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '150px'
  },
  {
    header: 'Seal Number Old',
    exportHead: 'Seal Number Old',
    field: 'SealNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Seal Number New',
    exportHead: 'Seal Number New',
    field: 'SealNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch DriverOld',
    exportHead: 'Dispatch DriverOld',
    field: 'DispatchDriverOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch DriverNew',
    exportHead: 'Dispatch DriverNew',
    field: 'DispatchDriverNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'ModeOf PaymentOld',
    exportHead: 'ModeOf PaymentOld',
    field: 'ModeOfPaymentOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'ModeOf PaymentNew',
    exportHead: 'ModeOf PaymentNew',
    field: 'ModeOfPaymentNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Payment TypeOld',
    exportHead: 'Payment TypeOld',
    field: 'PaymentTypeOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Payment TypeNew',
    exportHead: 'Payment TypeNew',
    field: 'PaymentTypeNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sending PartyOld',
    exportHead: 'Sending PartyOld',
    field: 'SendingPartyOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sending PartyNew',
    exportHead: 'Sending PartyNew',
    field: 'SendingPartyNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth:'150px'
  },
  {
    header: 'Sender Old',
    exportHead: 'Sender Old',
    field: 'SenderOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender New',
    exportHead: 'Sender New',
    field: 'SenderNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth:'150px'
  },
  {
    header: 'Sender AddressOld',
    exportHead: 'Sender AddressOld',
    field: 'SenderAddressOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender AddressNew',
    exportHead: 'Sender AddressNew',
    field: 'SenderAddressNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender MobileNoOld',
    exportHead: 'Sender MobileNoOld',
    field: 'SenderMobileNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender MobileNoNew',
    exportHead: 'Sender MobileNoNew',
    field: 'SenderMobileNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver PartyOld',
    exportHead: 'Receiver PartyOld',
    field: 'RecPartyOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver PartyNew',
    exportHead: 'Receiver PartyNew',
    field: 'RecPartyNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver NameOld',
    exportHead: 'Receiver NameOld',
    field: 'RecNameOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver NameNew',
    exportHead: 'Receiver NameNew',
    field: 'RecNameNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver AddressOld',
    exportHead: 'Receiver AddressOld',
    field: 'RecAddressOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver AddressNew',
    exportHead: 'Receiver AddressNew',
    field: 'RecAddressNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver Mobile Number Old',
    exportHead: 'Receiver Mobile Number Old',
    field: 'RecMobileNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver Mobile Number New',
    exportHead: 'Receiver Mobile Number New',
    field: 'RecMobileNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Items Old',
    exportHead: 'Items Old',
    field: 'ItemsOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Items New',
    exportHead: 'Items New',
    field: 'ItemsNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Freight Old',
    exportHead: 'Freight Old',
    field: 'FreightOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Freight New',
    exportHead: 'Freight New',
    field: 'FreightNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Document ChargesOld',
    exportHead: 'Document ChargesOld',
    field: 'DocumentChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Document ChargesNew',
    exportHead: 'Document ChargesNew',
    field: 'DocumentChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Insurance Old',
    exportHead: 'Insurance Old',
    field: 'InsuranceOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Insurance New',
    exportHead: 'Insurance New',
    field: 'InsuranceNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Delivery ChargesOld',
    exportHead: 'Delivery ChargesOld',
    field: 'DeliveryChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Delivery ChargesNew',
    exportHead: 'Delivery ChargesNew',
    field: 'DeliveryChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Collection ChargesOld',
    exportHead: 'Collection ChargesOld',
    field: 'CollectionChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Collection ChargesNew',
    exportHead: 'Collection ChargesNew',
    field: 'CollectionChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Cartage AmountOld',
    exportHead: 'Cartage AmountOld',
    field: 'CartageAmountOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Cartage AmountNew',
    exportHead: 'Cartage AmountNew',
    field: 'CartageAmountNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Net AmountOld',
    exportHead: 'Net AmountOld',
    field: 'NetAmountOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Net AmountNew',
    exportHead: 'Net AmountNew',
    field: 'NetAmountNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Remarks Old',
    exportHead: 'Remarks Old',
    field: 'RemarksOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Remarks New',
    exportHead: 'Remarks New',
    field: 'RemarksNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Commission Old',
    exportHead: 'Commission Old',
    field: 'CommissionOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Commission New',
    exportHead: 'Commission New',
    field: 'CommissionNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Demurrage Charge Old',
    exportHead: 'Demurrage Charge Old',
    field: 'DemurrageChgOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Demurrage Charge New',
    exportHead: 'Demurrage Charge New',
    field: 'DemurrageChgNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Hamali Charge Old',
    exportHead: 'Hamali Charge Old',
    field: 'HamaliChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Hamali Charge New',
    exportHead: 'Hamali Charge New',
    field: 'HamaliChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
]
export const PDFHeaderColumnsFormattedLRNOTwo = [
  {
    header: 'Formatted LR Number',
    exportHead: 'Formatted LR Number',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Entry Date',
    exportHead: 'Entry Date',
    field: 'EntryDate',
    minWidth: '100px',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'User Modified',
    exportHead: 'User Modified',
    field: 'UserIDModifiedNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking CityOld',
    exportHead: 'Booking CityOld',
    field: 'BookingCityOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking CityNew',
    exportHead: 'Booking CityNew',
    field: 'BookingCityNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking\nBranchOld',
    exportHead: 'Booking\nBranchOld',
    field: 'BookingBranchOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking\nBranchNew',
    exportHead: 'Booking BranchNew',
    field: 'BookingBranchNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination CityOld',
    exportHead: 'Destination CityOld',
    field: 'DestinationCityOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination CityNew',
    exportHead: 'Destination CityNew',
    field: 'DestinationCityNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination\nBranchOld',
    exportHead: 'Destination BranchOld',
    field: 'DestinationBranchOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination\nBranchNew',
    exportHead: 'Destination BranchNew',
    field: 'DestinationBranchNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination\nChangeRemarks',
    exportHead: 'Destination\nChangeRemarks',
    field: 'Remarks',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch CityOld',
    exportHead: 'Dispatch CityOld',
    field: 'DispatchCityOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch CityNew',
    exportHead: 'Dispatch CityNew',
    field: 'DispatchCityNew',
    xlCol: { dataType: 'quantity', dataFormatter: null, halign: 'left' },
    align: 'left',
  },
  {
    header: 'Dispatch\nBranchOld',
    exportHead: 'Dispatch BranchOld',
    field: 'DispatchBranchOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch\nBranchNew',
    exportHead: 'Dispatch BranchNew',
    field: 'DispatchBranchNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch OldVehicle',
    exportHead: 'Dispatch OldVehicle',
    field: 'DispatchVehicleOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '150px'
  },
  {
    header: 'Dispatch NewVehicle',
    exportHead: 'Dispatch NewVehicle',
    field: 'DispatchVehicleNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth: '150px'
  },
  {
    header: 'Seal Number Old',
    exportHead: 'Seal Number Old',
    field: 'SealNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Seal Number New',
    exportHead: 'Seal Number New',
    field: 'SealNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch DriverOld',
    exportHead: 'Dispatch DriverOld',
    field: 'DispatchDriverOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch DriverNew',
    exportHead: 'Dispatch DriverNew',
    field: 'DispatchDriverNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'ModeOf PaymentOld',
    exportHead: 'ModeOf PaymentOld',
    field: 'ModeOfPaymentOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'ModeOf PaymentNew',
    exportHead: 'ModeOf PaymentNew',
    field: 'ModeOfPaymentNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Payment TypeOld',
    exportHead: 'Payment TypeOld',
    field: 'PaymentTypeOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Payment TypeNew',
    exportHead: 'Payment TypeNew',
    field: 'PaymentTypeNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sending PartyOld',
    exportHead: 'Sending PartyOld',
    field: 'SendingPartyOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sending PartyNew',
    exportHead: 'Sending PartyNew',
    field: 'SendingPartyNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth:'150px'
  },
  {
    header: 'Sender Old',
    exportHead: 'Sender Old',
    field: 'SenderOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender New',
    exportHead: 'Sender New',
    field: 'SenderNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth:'150px'
  },
  {
    header: 'Sender AddressOld',
    exportHead: 'Sender AddressOld',
    field: 'SenderAddressOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender AddressNew',
    exportHead: 'Sender AddressNew',
    field: 'SenderAddressNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender MobileNoOld',
    exportHead: 'Sender MobileNoOld',
    field: 'SenderMobileNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender MobileNoNew',
    exportHead: 'Sender MobileNoNew',
    field: 'SenderMobileNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver PartyOld',
    exportHead: 'Receiver PartyOld',
    field: 'RecPartyOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver PartyNew',
    exportHead: 'Receiver PartyNew',
    field: 'RecPartyNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver NameOld',
    exportHead: 'Receiver NameOld',
    field: 'RecNameOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver NameNew',
    exportHead: 'Receiver NameNew',
    field: 'RecNameNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver AddressOld',
    exportHead: 'Receiver AddressOld',
    field: 'RecAddressOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver AddressNew',
    exportHead: 'Receiver AddressNew',
    field: 'RecAddressNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver Mobile Number Old',
    exportHead: 'Receiver Mobile Number Old',
    field: 'RecMobileNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver Mobile Number New',
    exportHead: 'Receiver Mobile Number New',
    field: 'RecMobileNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Items Old',
    exportHead: 'Items Old',
    field: 'ItemsOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Items New',
    exportHead: 'Items New',
    field: 'ItemsNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Freight Old',
    exportHead: 'Freight Old',
    field: 'FreightOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Freight New',
    exportHead: 'Freight New',
    field: 'FreightNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Document ChargesOld',
    exportHead: 'Document ChargesOld',
    field: 'DocumentChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Document ChargesNew',
    exportHead: 'Document ChargesNew',
    field: 'DocumentChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Insurance Old',
    exportHead: 'Insurance Old',
    field: 'InsuranceOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Insurance New',
    exportHead: 'Insurance New',
    field: 'InsuranceNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Delivery ChargesOld',
    exportHead: 'Delivery ChargesOld',
    field: 'DeliveryChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Delivery ChargesNew',
    exportHead: 'Delivery ChargesNew',
    field: 'DeliveryChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Collection ChargesOld',
    exportHead: 'Collection ChargesOld',
    field: 'CollectionChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Collection ChargesNew',
    exportHead: 'Collection ChargesNew',
    field: 'CollectionChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Cartage AmountOld',
    exportHead: 'Cartage AmountOld',
    field: 'CartageAmountOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Cartage AmountNew',
    exportHead: 'Cartage AmountNew',
    field: 'CartageAmountNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Net AmountOld',
    exportHead: 'Net AmountOld',
    field: 'NetAmountOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Net AmountNew',
    exportHead: 'Net AmountNew',
    field: 'NetAmountNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Remarks Old',
    exportHead: 'Remarks Old',
    field: 'RemarksOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Remarks New',
    exportHead: 'Remarks New',
    field: 'RemarksNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Commission Old',
    exportHead: 'Commission Old',
    field: 'CommissionOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Commission New',
    exportHead: 'Commission New',
    field: 'CommissionNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Demurrage Charge Old',
    exportHead: 'Demurrage Charge Old',
    field: 'DemurrageChgOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Demurrage Charge New',
    exportHead: 'Demurrage Charge New',
    field: 'DemurrageChgNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Hamali Charge Old',
    exportHead: 'Hamali Charge Old',
    field: 'HamaliChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Hamali Charge New',
    exportHead: 'Hamali Charge New',
    field: 'HamaliChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
]
export const PDFHeaderColumnsForBothTwo = [
  { header: 'LR Number', exportHead: 'LR Number', field: 'LRNO', xlCol: { dataType: 'quantity', dataFormatter: null }, align: 'left' },
  {
    header: 'Formatted LR Number',
    exportHead: 'Formatted LR Number',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Entry Date',
    exportHead: 'Entry Date',
    field: 'EntryDate',
    minWidth: '100px',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'User Modified',
    exportHead: 'User Modified',
    field: 'UserIDModifiedNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking CityOld',
    exportHead: 'Booking CityOld',
    field: 'BookingCityOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking CityNew',
    exportHead: 'Booking CityNew',
    field: 'BookingCityNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking\nBranchOld',
    exportHead: 'Booking\nBranchOld',
    field: 'BookingBranchOld',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Booking\nBranchNew',
    exportHead: 'Booking BranchNew',
    field: 'BookingBranchNew',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination CityOld',
    exportHead: 'Destination CityOld',
    field: 'DestinationCityOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination CityNew',
    exportHead: 'Destination CityNew',
    field: 'DestinationCityNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination\nBranchOld',
    exportHead: 'Destination BranchOld',
    field: 'DestinationBranchOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination\nBranchNew',
    exportHead: 'Destination BranchNew',
    field: 'DestinationBranchNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Destination\nChangeRemarks',
    exportHead: 'Destination\nChangeRemarks',
    field: 'Remarks',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch CityOld',
    exportHead: 'Dispatch CityOld',
    field: 'DispatchCityOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch CityNew',
    exportHead: 'Dispatch CityNew',
    field: 'DispatchCityNew',
    xlCol: { dataType: 'quantity', dataFormatter: null, halign: 'left' },
    align: 'left',
  },
  {
    header: 'Dispatch\nBranchOld',
    exportHead: 'Dispatch BranchOld',
    field: 'DispatchBranchOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch\nBranchNew',
    exportHead: 'Dispatch BranchNew',
    field: 'DispatchBranchNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch OldVehicle',
    exportHead: 'Dispatch OldVehicle',
    field: 'DispatchVehicleOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch NewVehicle',
    exportHead: 'Dispatch NewVehicle',
    field: 'DispatchVehicleNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Seal Number Old',
    exportHead: 'Seal Number Old',
    field: 'SealNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Seal Number New',
    exportHead: 'Seal Number New',
    field: 'SealNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch DriverOld',
    exportHead: 'Dispatch DriverOld',
    field: 'DispatchDriverOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Dispatch DriverNew',
    exportHead: 'Dispatch DriverNew',
    field: 'DispatchDriverNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'ModeOf PaymentOld',
    exportHead: 'ModeOf PaymentOld',
    field: 'ModeOfPaymentOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'ModeOf PaymentNew',
    exportHead: 'ModeOf PaymentNew',
    field: 'ModeOfPaymentNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Payment TypeOld',
    exportHead: 'Payment TypeOld',
    field: 'PaymentTypeOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Payment TypeNew',
    exportHead: 'Payment TypeNew',
    field: 'PaymentTypeNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sending PartyOld',
    exportHead: 'Sending PartyOld',
    field: 'SendingPartyOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sending PartyNew',
    exportHead: 'Sending PartyNew',
    field: 'SendingPartyNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth:'150px'
  },
  {
    header: 'Sender Old',
    exportHead: 'Sender Old',
    field: 'SenderOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender New',
    exportHead: 'Sender New',
    field: 'SenderNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
    minWidth:'150px'
  },
  {
    header: 'Sender AddressOld',
    exportHead: 'Sender AddressOld',
    field: 'SenderAddressOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender AddressNew',
    exportHead: 'Sender AddressNew',
    field: 'SenderAddressNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender MobileNoOld',
    exportHead: 'Sender MobileNoOld',
    field: 'SenderMobileNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender MobileNoNew',
    exportHead: 'Sender MobileNoNew',
    field: 'SenderMobileNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver PartyOld',
    exportHead: 'Receiver PartyOld',
    field: 'RecPartyOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver PartyNew',
    exportHead: 'Receiver PartyNew',
    field: 'RecPartyNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver NameOld',
    exportHead: 'Receiver NameOld',
    field: 'RecNameOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver NameNew',
    exportHead: 'Receiver NameNew',
    field: 'RecNameNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver AddressOld',
    exportHead: 'Receiver AddressOld',
    field: 'RecAddressOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver AddressNew',
    exportHead: 'Receiver AddressNew',
    field: 'RecAddressNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver Mobile Number Old',
    exportHead: 'Receiver Mobile Number Old',
    field: 'RecMobileNoOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver Mobile Number New',
    exportHead: 'Receiver Mobile Number New',
    field: 'RecMobileNoNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Items Old',
    exportHead: 'Items Old',
    field: 'ItemsOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Items New',
    exportHead: 'Items New',
    field: 'ItemsNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Freight Old',
    exportHead: 'Freight Old',
    field: 'FreightOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Freight New',
    exportHead: 'Freight New',
    field: 'FreightNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Document ChargesOld',
    exportHead: 'Document ChargesOld',
    field: 'DocumentChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Document ChargesNew',
    exportHead: 'Document ChargesNew',
    field: 'DocumentChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Insurance Old',
    exportHead: 'Insurance Old',
    field: 'InsuranceOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Insurance New',
    exportHead: 'Insurance New',
    field: 'InsuranceNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Delivery ChargesOld',
    exportHead: 'Delivery ChargesOld',
    field: 'DeliveryChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Delivery ChargesNew',
    exportHead: 'Delivery ChargesNew',
    field: 'DeliveryChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Collection ChargesOld',
    exportHead: 'Collection ChargesOld',
    field: 'CollectionChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Collection ChargesNew',
    exportHead: 'Collection ChargesNew',
    field: 'CollectionChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Cartage AmountOld',
    exportHead: 'Cartage AmountOld',
    field: 'CartageAmountOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Cartage AmountNew',
    exportHead: 'Cartage AmountNew',
    field: 'CartageAmountNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Net AmountOld',
    exportHead: 'Net AmountOld',
    field: 'NetAmountOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Net AmountNew',
    exportHead: 'Net AmountNew',
    field: 'NetAmountNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Remarks Old',
    exportHead: 'Remarks Old',
    field: 'RemarksOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Remarks New',
    exportHead: 'Remarks New',
    field: 'RemarksNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Commission Old',
    exportHead: 'Commission Old',
    field: 'CommissionOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Commission New',
    exportHead: 'Commission New',
    field: 'CommissionNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Demurrage Charge Old',
    exportHead: 'Demurrage Charge Old',
    field: 'DemurrageChgOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Demurrage Charge New',
    exportHead: 'Demurrage Charge New',
    field: 'DemurrageChgNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Hamali Charge Old',
    exportHead: 'Hamali Charge Old',
    field: 'HamaliChargesOld',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
  {
    header: 'Hamali Charge New',
    exportHead: 'Hamali Charge New',
    field: 'HamaliChargesNew',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'right',
  },
]
export const LrDetailsColumns = [
  { header: 'LRNO', exportHead: 'LRNO', field: 'LRNo', xlCol: { dataType: 'quantity', dataFormatter: null }, align: 'left' },
  {
    header: 'FormattedLR',
    exportHead: 'FormattedLR',
    field: 'FormattedLRNo',
    minWidth: '100px',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'ManualLrNO',
    exportHead: 'ManualLrNO',
    field: 'ManualLRNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Book DateTime',
    exportHead: 'Book DateTime',
    field: 'BookingDateTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Pmt Type',
    exportHead: 'Pmt Type',
    field: 'PaymentTypeDet',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Sender Name',
    exportHead: 'Sender Name',
    field: 'Sender',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'Receiver Name',
    exportHead: 'Receiver Name',
    field: 'RecName',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    header: 'From City',
    exportHead: 'From City',
    field: 'FromCity',
    xlCol: { dataType: 'quantity', dataFormatter: null },
    align: 'left',
  },
  { header: 'To City', exportHead: 'To City', field: 'ToCity', xlCol: { dataType: 'quantity', dataFormatter: null }, align: 'left' },
]
